import { createFileRoute, Outlet, redirect, stripSearchParams } from "@tanstack/react-router";

import { authQueries } from "@/api/resources/auth/queries";
import { deploymentsQueries } from "@/api/resources/deployments/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { defaultGlobalFilters, globalFiltersSearchSchema } from "@/providers/globalFiltersConfig";

export const Route = createFileRoute("/_auth")({
  validateSearch: globalFiltersSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultGlobalFilters)],
  },
  beforeLoad: async ({ context }) => {
    // redirect to login if no claims exists
    // ! Previously used `ensureQueryData` here, but this lead to invalid cached results, leading to fetch-permission-errors
    const claims = await context.queryClient.fetchQuery(authQueries.getAuthClaims());
    if (!claims) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.pathname,
        },
      });
    }
    return { claims };
  },
  loader: async ({ context }) => {
    await Promise.allSettled([
      context.queryClient.ensureQueryData(workspacesQueries.listAll()),
      context.queryClient.ensureQueryData(deploymentsQueries.listAll()),
    ]);
  },
  component: () => <Outlet />,
});
